var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgFormName = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "0 0 12 17",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mobile-Product-Setup",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "2.4.1-Create-Creditpass-General",
    transform: "translate(-24.000000, -140.000000)",
    stroke: "currentColor"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Cells-/-Small-Image",
    transform: "translate(0.000000, 124.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(15.000000, 10.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(10.000000, 6.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-1",
    points: "0 15.9999 10 15.9999 10 1.9999 0 1.9999"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1.4361,
    y1: 12.5879,
    x2: 6.4241,
    y2: 12.5879,
    id: "Stroke-3"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1.4361,
    y1: 14.1553,
    x2: 8.4761,
    y2: 14.1553,
    id: "Stroke-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.6314,10.4448 L2.6314,9.7618 C2.6314,8.4848 3.6924,7.4488 5.0004,7.4488 C6.3084,7.4488 7.3684,8.4848 7.3684,9.7618 L7.3684,10.4448 L2.6314,10.4448 Z",
    id: "Stroke-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.9518,4.7822 C3.9518,4.2072 4.4178,3.7412 4.9928,3.7412 C5.5658,3.7412 6.0328,4.2072 6.0328,4.7822 C6.0328,5.3572 5.5658,5.8232 4.9928,5.8232 C4.4178,5.8232 3.9518,5.3572 3.9518,4.7822 Z",
    id: "Stroke-6"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3.8453,
    y1: 0,
    x2: 3.8453,
    y2: 2,
    id: "Stroke-7"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6.1549,
    y1: 0,
    x2: 6.1549,
    y2: 2,
    id: "Stroke-8"
  }))))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgFormName, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/formName.3896d355.svg";
export { ForwardRef as ReactComponent };